class FaqFilter extends HTMLElement {
  constructor() {
    super();
    this.tabs = this.querySelectorAll(".faq-filter__tab");
    this.sections = document.querySelectorAll(".js-faq-section");
  }

  connectedCallback() {
    this.tabs.forEach(tab =>
      tab.addEventListener("click", () => this.onTabClick(tab))
    );
  }

  onTabClick(tab) {
    if (tab.classList.contains("is-active")) return;

    this.tabs.forEach(t => t.classList.remove("is-active"));
    tab.classList.add("is-active");

    const target = tab.dataset.target;

    if (target === "all") {
      this.showAll();
    } else {
      this.showOnly(target);
    }

    this.scrollIntoView({
      behavior: "smooth",
      block: "start"
    });
  }

  showAll() {
    this.sections.forEach(section => {
      section.style.display = "";
    });
  }

  showOnly(id) {
    this.sections.forEach(section => {
      section.style.display = section.id === id ? "" : "none";
    });
  }
}

customElements.define("faq-filter", FaqFilter);


